const AUTH_TOKEN_KEY = 'pikado_auth_token';
const AUTH_USER_KEY = 'pikado_user';

function parseJwtPayload(token: string | null): any | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

export function getStoredAuthUser(): any | null {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getCurrentAuthUserId(): string {
  const user = getStoredAuthUser();
  const tokenPayload = parseJwtPayload(localStorage.getItem(AUTH_TOKEN_KEY));

  return (
    user?._id ||
    user?.id ||
    user?.keycloakId ||
    user?.cognitoUserId ||
    tokenPayload?.sub ||
    'unknown'
  );
}

export function getCurrentAuthEmail(): string | undefined {
  const user = getStoredAuthUser();
  const tokenPayload = parseJwtPayload(localStorage.getItem(AUTH_TOKEN_KEY));

  return user?.email || tokenPayload?.email;
}

export function getCurrentAuthUsername(): string | undefined {
  const user = getStoredAuthUser();
  const tokenPayload = parseJwtPayload(localStorage.getItem(AUTH_TOKEN_KEY));

  return (
    user?.preferred_username ||
    user?.email ||
    tokenPayload?.preferred_username ||
    tokenPayload?.email
  );
}
